import { Vector3 } from "flavr-math";
import { StateMachine, StateNode } from "../shared/StateMachine";
export class TrainingObject extends StateMachine {
    constructor(objectId, modelUid, modelName, states, transitions, position, copyCollider = true) {
        super();
        this.id = objectId;
        this.modelUid = modelUid;
        this.modelName = modelName;
        this.states = states;
        this.transitions = transitions;
        this.position = position !== null && position !== void 0 ? position : new Vector3(0, 0, 0);
        this.copyCollider = copyCollider;
        const nodes = this.createStateNodes(states, transitions);
        if (nodes !== undefined) {
            this.setStartNode(nodes.startNode);
            this.setAllStates(nodes.allNodes);
        }
    }
    containsModel(uid) {
        var _a;
        return (((_a = this.states) === null || _a === void 0 ? void 0 : _a.some((value) => value.modelUid === uid)) === true) || uid === this.modelUid;
    }
    createStateNodes(states, transitions) {
        if (states.length === 0)
            return undefined;
        // Create states
        const stateNodes = states.map(state => new StateNode(state));
        const rootNode = stateNodes[0];
        const nodeMap = new Map(stateNodes.map(stateNode => [stateNode.data.name, stateNode]));
        // Create transitions
        transitions.forEach(transition => {
            const startNode = nodeMap.get(transition.startState);
            const endNode = nodeMap.get(transition.endState);
            if (startNode === undefined || endNode === undefined)
                return;
            startNode.addTransition(endNode, {
                evaluate(context) {
                    const event = context.trainingEventMetaInformation.get(transition.eventId);
                    return event !== undefined;
                }
            });
        });
        return { startNode: rootNode, allNodes: stateNodes };
    }
}
